import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import CompanyPromotion from "../PdfQuotationsTablesV2/company_promotion";
import ElectricFittings from "../PdfQuotationsTablesV2/electric_fittings";
import performRequest from "../../../api/request";
import { useNavigate, useParams } from "react-router-dom";
import CompanyDescription from "../PdfQuotationsTablesV2/company_description";
import NVPHSpecifications from "../PdfQuotationsTablesV2/nvph_specifications";
import FanPadSpecifications from "../PdfQuotationsTablesV2/fan_pad_specifications";
import AFrameSetup from "../PdfQuotationsTablesV2/a_frame_setup";
import FlatBedSetup from "../PdfQuotationsTablesV2/flat_bed_setup";
import GrowBagSetup from "../PdfQuotationsTablesV2/grow_bag_setup";
import DutchBucketSetup from "../PdfQuotationsTablesV2/dutch_bucket_setup";
import WaterStorageHandling from "../PdfQuotationsTablesV2/water_storage_and_handling";
import EmployeeTrainingProgramme from "../PdfQuotationsTablesV2/employee_training_programme";
import AgronomySupport from "../PdfQuotationsTablesV2/agronomy_support";
import ScopeOfWork from "../PdfQuotationsTablesV2/scope_of_work";
import CustomerResponsibility from "../PdfQuotationsTablesV2/customer_responsibility";
import CivilMaterials from "../PdfQuotationsTablesV2/civil_materials";
import SoftwareServices from "../PdfQuotationsTablesV2/software_services";
import MaterialBreakdown from "../PdfQuotationsTablesV2/material_breakdown";
import WorkOrderLocations from "../PdfQuotationsTablesV2/work_order_locations";
import WarrantyOnMaterial from "../PdfQuotationsTablesV2/warranty_on_material";
import TrackingOfProgress from "../PdfQuotationsTablesV2/tracking_of_progress";
import NetHouseSpecifications from "../PdfQuotationsTablesV2/net_house_specifications";
import PaymentDetails from "../PdfQuotationsTablesV2/payment_details";
import SimpleButton from "../../../Components/layouts/simple_button";
import { Toast } from "../../../CustomComponent/toast";
import KryzenTop from "../PdfQuotationsTablesV2/kryzen_Top";
import ProjectFinancials from "../PdfQuotationsTablesV2/project_financials";
import QuotationAmounts from "../PdfQuotationsTablesV2/quotation_amounts";
import PaymentBreakdown from "../PdfQuotationsTablesV2/payment_breakdown";
import ProduceBreakevenTable from "../PdfQuotationsTablesV2/produce_breakeven_table";
import UserDetails from "../PdfQuotationsTablesV2/user_details";
import MaterialBreakdownCEA from "../PdfQuotationsTablesV2/material_breakdown_CEA";
import LoadingPage from "../../../Components/layouts/loading";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcSurvey } from "react-icons/fc";
import WhatsAppButton from "../../../Components/layouts/whatsApp_button";
import CEACompo from "../../../certificates/CEACompo.jpg";
import CSofHydroponics from "../../../certificates/CSofHydroponics.jpg";
import Camparison from "../PdfQuotationsTablesV2/camparison";
import { getQuotationFor } from "../../../Components/Functions/word.fun";
import Soilbased_precision_farming from "../PdfQuotationsTablesV2/soilbased_precision_farming";
const QuotationPreviewV2 = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [allQData, setAllQData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/quotations/getQuotationsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setdata(res.data?.input_info);
          setAllQData(res.data);
        } else {
          Toast("error", "Error while getting Quotations!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [refresh, id]);
  const [sendingWhatspp, setSendingWhatspp] = useState(false);

  function QuotationNumber() {
    return id.toString().padStart(4, "0");
  }
  function GetArea() {
    let area = data?.bay_size * data?.span_size;
    return area;
  }

  function joinWithDash(inputString) {
    var wordsArray = inputString.split(" ");
    var joinedString = wordsArray.join("-");
    return joinedString;
  }
  const printPDF = () => {
    let name = joinWithDash(
      `${QuotationNumber()}-${GetArea()}SqM-${
        data?.businessName || data?.contactPersonName
      }-${getQuotationFor(allQData?.input_info)}.pdf`
    );
    document.title = name;
    window.print();
  };
  const handleGenerateAndSendWhatsAppPDF = () => {
    const htmlContent = document.getElementById("pdf-content").innerHTML;
    let name = joinWithDash(
      `${QuotationNumber()}-${GetArea()}SqM-${
        data?.businessName || data?.contactPersonName
      }-${getQuotationFor(allQData?.input_info)}.pdf`
    );
    if (!data?.whatsAppNumber) {
      Toast("error", "WhatsApp number not added for this Quotations!");
    } else if (data?.whatsAppNumber && data?.whatsAppNumber?.length !== 10) {
      Toast("error", "WhatsApp number must be of 10 digits!");
    } else {
      setSendingWhatspp(true);
      performRequest("POST", "/quotations/sendQuotationToWhatsapp", {
        quotDetails: data,
        pdfName: name,
        htmlContent,
      })
        .then((res) => {
          if (res.status === 200) {
            Toast(
              "success",
              `Pdf sent successfully on whatsapp ${data.whatsAppNumber}`
            );
          } else {
            Toast("error", "error while sending!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setSendingWhatspp(false));
    }
  };
  function generatePDF() {
    setLoading(true);
    performRequest("PATCH", `/quotations/updateQuotations/${id}`, {
      pdfStatus: true,
    })
      .then((res) => {
        if (res.status === 200) {
          setRefresh(!refresh);
          Toast("success", "PDF generated successfully!");
        } else {
          Toast("error", "Error while generating PDF!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }

  function handelEdit() {
    navigate(`/custom-quotation/edit-quotation/${id}`);
  }
  const duplicateQuotation = () => {
    navigate(`/custom-quotation/new-quotation?duplicate=${id}`);
  };
  useEffect(() => {
    if (data?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("pdf-content");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [data]);
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcSurvey className="fs-2  me-1" /> Custom quotations
                </h2>
                <h4 className="text-muted">
                  Custom quotation for{" "}
                  {data?.businessName || data?.contactPersonName}
                </h4>
              </div>
              {allQData?.input_info?.pdfStatus && (
                <div className="col-md-4">
                  <div className="btn-list justify-content-end">
                    <WhatsAppButton
                      buttonText={sendingWhatspp ? "SENDING..." : "SEND QUOTE"}
                      disabled={sendingWhatspp ? true : false}
                      style={{
                        height: "46px",
                        marginTop: "8px",
                        backgroundColor: "#10c245",
                        color: "white",
                      }}
                      svg={
                        sendingWhatspp ? (
                          <div
                            class="spinner-border me-2 fs-1 spinner-border-sm text-white"
                            role="status"
                          ></div>
                        ) : (
                          ""
                        )
                      }
                      onClick={handleGenerateAndSendWhatsAppPDF}
                    />
                    <SimpleButton buttonText={"save pdf"} onClick={printPDF} />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" id="pdf-content">
              {data &&
                (data?.quotationType === "fanpad" ||
                  data?.quotationType === "nethouse" ||
                  data?.quotationType === "nvph" ||
                  data?.quotationType === "soilbasedfanpad" ||
                  data?.quotationType === "soilbasednvph" ||
                  data?.quotationType === "soilbasednethouse") && (
                  <>
                    <KryzenTop />
                    {data && (
                      <CompanyDescription
                        allQData={allQData}
                        businessName={
                          data?.businessName || data?.contactPersonName
                        }
                        address={data?.address}
                        data={data}
                        quotationType={data?.quotationType}
                      />
                    )}
                    {data && (
                      <UserDetails userInfo={data} area={allQData?.area_in} />
                    )}

                    {data &&
                      (data?.quotationType === "fanpad" ||
                        data?.quotationType === "soilbasedfanpad") && (
                        <FanPadSpecifications />
                      )}

                    {data &&
                      (data?.quotationType === "nethouse" ||
                        data?.quotationType === "soilbasednethouse") && (
                        <NetHouseSpecifications />
                      )}

                    {data &&
                      (data?.quotationType === "nvph" ||
                        data?.quotationType === "soilbasednvph") && (
                        <NVPHSpecifications />
                      )}

                    {data &&
                      (data?.quotationType === "soilbasedfanpad" ||
                        data?.quotationType === "soilbasednvph" ||
                        data?.quotationType === "soilbasednethouse") &&
                      (data?.asPerIndustry?.includes("drip_system") ||
                        data?.asPerIndustry?.includes(
                          "trellising_installation"
                        ) ||
                        data?.asPerIndustry?.includes("bed_preparation") ||
                        data?.asPerIndustry?.includes(
                          "mulching_sheet_installation"
                        )) && (
                        <Soilbased_precision_farming
                          asPerIndustry={data?.asPerIndustry}
                        />
                      )}

                    {
                      <div style={{ pageBreakInside: "avoid" }}>
                        <div>
                          <img src={CEACompo} alt="CEACompo" />
                        </div>
                      </div>
                    }

                    {data && data?.foggerSystem && (
                      <WaterStorageHandling
                        quotationType={data?.quotationType}
                      />
                    )}
                    {data &&
                      data?.quotationType !== "nvph" &&
                      data?.quotationType !== "soilbasednvph" &&
                      data?.quotationType !== "soilbasednethouse" &&
                      data?.quotationType !== "nethouse" && (
                        <ElectricFittings data={data} />
                      )}

                    {data && (
                      <TrackingOfProgress quotationType={data?.quotationType} />
                    )}
                    {data && (
                      <ScopeOfWork quotationType={data?.quotationType} />
                    )}
                    {data && (
                      <CustomerResponsibility
                        quotationType={data?.quotationType}
                      />
                    )}
                    {data && (
                      <CivilMaterials quotationType={data?.quotationType} />
                    )}
                    {/* working panding */}
                    {/* <AfterSalesServices_AMC /> */}

                    {
                      <MaterialBreakdownCEA
                        quotationType={data?.quotationType}
                        data
                      />
                    }
                    {data && (
                      <WorkOrderLocations quotationType={data?.quotationType} />
                    )}
                    <WarrantyOnMaterial
                      quotationType={data?.quotationType}
                      data
                    />
                    <CompanyPromotion />
                    {data && data?.showProjectFinancials && (
                      <>
                        {data && data?.showProjectFinancials && allQData && (
                          <ProjectFinancials
                            allQData={allQData}
                            quotationType={data?.quotationType}
                          />
                        )}
                        {allQData &&
                          allQData?.plant_grow?.updatedPlantsList && (
                            <ProduceBreakevenTable allQData={allQData} />
                          )}
                        <div
                          className="html2pdf__page-break"
                          style={{
                            pageBreakAfter: "always",
                            display: "block",
                            clear: "both",
                          }}
                        ></div>
                      </>
                    )}

                    <KryzenTop />
                    {allQData && (
                      <QuotationAmounts
                        allQData={allQData}
                        quotationType={data?.quotationType}
                      />
                    )}
                    {allQData && <PaymentBreakdown allQData={allQData} />}
                    {data && <PaymentDetails data={data} />}
                  </>
                )}
              {data &&
                data?.quotationType !== "fanpad" &&
                data?.quotationType !== "nethouse" &&
                data?.quotationType !== "nvph" &&
                data?.quotationType !== "soilbasedfanpad" &&
                data?.quotationType !== "soilbasednvph" &&
                data?.quotationType !== "soilbasednethouse" && (
                  <>
                    <KryzenTop />
                    {data && (
                      <CompanyDescription
                        allQData={allQData}
                        businessName={
                          data?.businessName || data?.contactPersonName
                        }
                        address={data?.address}
                        data={data}
                        quotationType={data?.quotationType}
                      />
                    )}
                    {data && (
                      <UserDetails userInfo={data} area={allQData?.area_in} />
                    )}

                    {data &&
                      data?.quotationType === "fanpad with hydroponics" && (
                        <FanPadSpecifications />
                      )}

                    {data &&
                      data?.quotationType === "nethouse with hydroponics" && (
                        <NetHouseSpecifications />
                      )}

                    {data &&
                      data?.quotationType === "nvph with hydroponics" && (
                        <NVPHSpecifications />
                      )}

                    {data?.quotationType !== "hydroponics only" && (
                      <div>
                        <div>
                          <img src={CEACompo} alt="CEACompo" />
                        </div>
                        <div
                          className="html2pdf__page-break"
                          style={{
                            pageBreakAfter: "always",
                            display: "block",
                            clear: "both",
                          }}
                        ></div>
                      </div>
                    )}
                    {
                      <div>
                        <div>
                          <img src={CSofHydroponics} alt="hydroCompo" />
                        </div>
                        <div
                          className="html2pdf__page-break"
                          style={{
                            pageBreakAfter: "always",
                            display: "block",
                            clear: "both",
                          }}
                        ></div>
                      </div>
                    }

                    {
                      <>
                        {data && data?.flatBedPercent > 0 && <FlatBedSetup />}
                        {data && data?.a_FramePercent > 0 && <AFrameSetup />}
                        {data && data?.growBagPercent > 0 && <GrowBagSetup />}
                        {data && data?.dutchBucketPercent > 0 && (
                          <DutchBucketSetup />
                        )}
                      </>
                    }

                    {data && (
                      <WaterStorageHandling
                        quotationType={data?.quotationType}
                        data={data}
                      />
                    )}
                    {data && <ElectricFittings data={data} />}
                    {
                      <>
                        <EmployeeTrainingProgramme />
                        <AgronomySupport />
                      </>
                    }
                    <TrackingOfProgress />
                    {data && (
                      <ScopeOfWork
                        quotationType={data?.quotationType}
                        a_FramePercent={data?.a_FramePercent}
                        flatBedPercent={data?.flatBedPercent}
                        growBagPercent={data?.growBagPercent}
                        dutchBucketPercent={data?.dutchBucketPercent}
                      />
                    )}
                    {data && (
                      <CustomerResponsibility
                        quotationType={data?.quotationType}
                      />
                    )}
                    <CivilMaterials
                      quotationType={data?.quotationType}
                      a_FramePercent={data?.a_FramePercent}
                      flatBedPercent={data?.flatBedPercent}
                      growBagPercent={data?.growBagPercent}
                      dutchBucketPercent={data?.dutchBucketPercent}
                    />
                    {/* working panding */}
                    {/* <AfterSalesServices_AMC /> */}
                    {<SoftwareServices />}
                    {data && data?.quotationType !== "hydroponics only" && (
                      <MaterialBreakdown quotationType={data?.quotationType} />
                    )}
                    {data && (
                      <WorkOrderLocations
                        quotationType={data?.quotationType}
                        a_FramePercent={data?.a_FramePercent}
                        flatBedPercent={data?.flatBedPercent}
                        growBagPercent={data?.growBagPercent}
                        dutchBucketPercent={data?.dutchBucketPercent}
                        allQData={allQData}
                      />
                    )}
                    <Camparison />
                    {data && (
                      <WarrantyOnMaterial
                        data
                        quotationType={data?.quotationType}
                      />
                    )}
                    <CompanyPromotion />
                    {data && data?.showProjectFinancials && (
                      <>
                        {data && data?.showProjectFinancials && allQData && (
                          <ProjectFinancials
                            allQData={allQData}
                            quotationType={data?.quotationType}
                          />
                        )}
                        {allQData &&
                          allQData?.plant_grow?.updatedPlantsList && (
                            <ProduceBreakevenTable allQData={allQData} />
                          )}
                        <div
                          className="html2pdf__page-break"
                          style={{
                            pageBreakAfter: "always",
                            display: "block",
                            clear: "both",
                          }}
                        ></div>
                      </>
                    )}
                    <KryzenTop />
                    {allQData && (
                      <QuotationAmounts
                        allQData={allQData}
                        quotationType={data?.quotationType}
                      />
                    )}
                    {allQData && <PaymentBreakdown allQData={allQData} />}
                    {data && <PaymentDetails data={data} />}
                  </>
                )}
            </div>
            <div className="card-footer d-print-none">
              <div className="btn-list justify-content-end">
                {!allQData?.input_info?.pdfStatus && (
                  <SimpleButton
                    buttonText="Genarate PDF"
                    onClick={generatePDF}
                  />
                )}

                {allQData?.input_info?.pdfStatus && (
                  <SimpleButton buttonText="Print PDF" onClick={printPDF}>
                    Print PDF
                  </SimpleButton>
                )}

                <button
                  disabled={data?.finalQuotation}
                  className={`btn mx-1 mt-2 btn-primary`}
                  onClick={handelEdit}
                >
                  EDIT QUOTATION
                </button>
                <SimpleButton
                  buttonText="Duplicate"
                  onClick={duplicateQuotation}
                />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default QuotationPreviewV2;
